import { PlusIcon } from '@phosphor-icons/react';
import { Button } from 'components/button/Button';
import { Card } from 'components/Card';
import { Formik } from 'components/form/formik';
import diff from 'object-diff';
import { useMemo } from 'react';
import toast from 'react-hot-toast';
import * as Yup from 'yup';

import { InputField } from '../../../components/input/InputField';
import { updateGeneralSettings } from '../models';
import { getDisplayError } from '../../../utils/get-display-error';
import { useAllGeneralSettings } from '../all-settings-context';
import { CheckboxField } from '../../../components/checkbox/CheckboxField';
import { captureException } from '@sentry/react';

const transporeonSettingsSchema = Yup.object().shape({
  transporeonImportEnabled: Yup.bool().required('Vereist'),
  transporeonUsername: Yup.string().required('Vereist'),
  transporeonCompanyId: Yup.string().required('Vereist'),
  transporeonPassword: Yup.string().required('Vereist'),
});

interface ITransporeonSettingsValues {
  transporeonImportEnabled: boolean;
  transporeonUsername: string;
  transporeonCompanyId: string;
  transporeonPassword: string;
}

export const TransporeonSettingsPage = () => {
  const { settings } = useAllGeneralSettings();

  const initialValues: ITransporeonSettingsValues = useMemo(() => {
    return {
      transporeonImportEnabled: settings.transporeonImportEnabled ?? false,
      transporeonUsername: settings.transporeonUsername ?? '',
      transporeonCompanyId: settings.transporeonCompanyId ?? '',
      transporeonPassword: settings.transporeonPassword ?? '',
    };
  }, [settings]);

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={transporeonSettingsSchema}
      onSubmit={async (values) => {
        try {
          const patch: Partial<typeof values> = diff(initialValues, values);
          await updateGeneralSettings(patch);
          toast.success('Transporeon instellingen aangepast');
        } catch (err: any) {
          captureException(err);
          toast.error('Kon transporeon instellingen niet aanpassen: ' + getDisplayError(err));
        }
      }}
    >
      {({ handleSubmit, isSubmitting }) => {
        return (
          <form onSubmit={handleSubmit} className="grid gap-4">
            <Card title="Instellingen">
              <CheckboxField
                labelText="Transporeon sync actief"
                name="transporeonImportEnabled"
                helperText="Importeer orders automatisch vanuit Transporeon."
              />
            </Card>

            <Card title="Inloggegevens" subtitle="Het Transporeon account dat voor de import wordt gebruikt.">
              <InputField labelText="Transporeon gebruikersnaam" type="text" name="transporeonUsername" />
              <InputField labelText="Transporeon company id" type="text" name="transporeonCompanyId" />
              <InputField labelText="Transporeon wachtwoord" type="password" name="transporeonPassword" />
            </Card>

            <div>
              <Button
                type="submit"
                color="primary"
                isDisabled={isSubmitting}
                isLoading={isSubmitting}
                iconLeft={<PlusIcon className="button-icon" />}
              >
                Pas instellingen aan
              </Button>
            </div>
          </form>
        );
      }}
    </Formik>
  );
};
